import { useDataContext } from 'Simple/Data'

export default function useDataTransform(props) {
  let [data] = useDataContext({ context: 'settings', viewPath: props.viewPath })

  return data._touched.size > 0
}
